export default {"src":"/_next/static/media/missions.002ea69b.svg","height":290,"width":391,"blurWidth":0,"blurHeight":0};